module.exports = __webpack_public_path__ + "static/media/header-logo.2df69897.svg";